import Text from "components/Text";
import { FC, memo } from "react";
import { colors } from "theme/colors";
import { WithStyle } from "utils/WithStyle";
import { IconImage, ItemWrapper } from "./Item.styled";
import { SidebarItemProps } from "./types";

const Component: FC<SidebarItemProps> = memo(({ icon, isActive, title, ...restProps }) => {
    return (
        <ItemWrapper isActive={isActive} {...restProps}>
            {icon && typeof icon === "string" ? (
                <IconImage src={icon} alt="Sidebar Icon Item Image" />
            ) : (
                icon
            )}
            <Text
                variant="label"
                color={isActive ? colors.purple.primary : colors.grey.secondary}
            >
                {title}
            </Text>
        </ItemWrapper>
    );
});

export const Item: FC<SidebarItemProps> & WithStyle = Object.assign(Component, {
    Style: ItemWrapper,
});
